import { SpaceInfo } from '../state/SpaceInfo';
import { CallReorderItem } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';
import { ReorderItemAction } from './ReorderItem';

export interface CallReorderItemAction extends ReorderItemAction {}

export function callReorderItem(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): CallReorderItemAction {
  return {
    type: CallReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isCallReorderItemAction = isActionFactory<CallReorderItemAction>(CallReorderItem);
